// extracted by mini-css-extract-plugin
module.exports = {"container":"Pan_container__jNIYk"};